<template>
  <el-dialog :title="title"
             :close-on-click-modal="false"
             width="500px"
             @closed="close"
             :visible.sync="visible">
    <el-form ref="form"
             :model="form"
             :rules="formRules"
             size="medium"
             label-width="100px"
             @submit.native.prevent="onSubmit()">
      <el-form-item label="实习生" prop="intern_user_id">
        <remote-select
          v-model="form.intern_user_id"
          placeholder="请输入实习生姓名搜索"
          clearable
          class="width-max"
          id-key="id"
          label-key="name"
          value-key="id"
          keyword-key="name"
          :query-request="getInternUserTable"
          :find-request="getTargetInternUserDetail">
        </remote-select>
      </el-form-item>
      <el-form-item label="日期" prop="plan_date">
        <el-date-picker
          v-model="form.plan_date"
          type="date"
          placeholder="请选择日期"
          value-format="yyyy-MM-dd"
          class="width-max"
          :picker-options="datePickerOptions"
          clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item label="目标值单量" prop="plan_order_count">
        <el-input-number
          v-model="form.plan_order_count"
          :min="1"
          :precision="0"
          class="width-max">
        </el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close()">取消</el-button>
      <el-button type="primary"
                 @click="onSubmit()">提交
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import RemoteSelect from '@core/components/RemoteSelect'

export default {
  components: {
    RemoteSelect,
  },
  props: {
    projectId: {
      type: [String, Number],
      required: true,
    },
    auditProjectRangeId: {
      type: [String, Number],
      default: null,
    },
  },
  data () {
    return {
      visible: false,
      formRules: {
        intern_user_id: [
          {required: true, message: '请选择实习生', trigger: 'change'},
        ],
        plan_date: [
          {required: true, message: '请选择日期', trigger: 'change'},
        ],
        plan_order_count: [
          {required: true, message: '请输入目标值单量', trigger: 'blur'},
          {type: 'number', min: 1, message: '目标值单量必须大于等于1', trigger: 'blur'},
        ],
      },
      form: {
        intern_user_id: null,
        plan_date: null,
        plan_order_count: 1,
      },
    }
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.login.user,
    }),
    title () {
      return '添加目标值'
    },
    datePickerOptions () {
      return {
        disabledDate: time => {
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          return time.getTime() < today.getTime()
        },
      }
    },
  },
  methods: {
    /**
     * 获取实习生列表
     */
    getInternUserTable (params) {
      return request('queryInternTableApi', params)
    },
    /**
     * 获取实习生详情
     */
    getTargetInternUserDetail (params) {
      return request('getTargetInternUserDetail', params)
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.create(this.form)
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create (data) {
      const submitData = {
        audit_project_range_id: this.auditProjectRangeId,
        projectid: this.projectId,
        intern_user_id: data.intern_user_id,
        plan_date: data.plan_date,
        plan_order_count: data.plan_order_count,
        creator: this.user.name || this.user.username || '',
      }

      request.common('createTargetValue', submitData).then(() => {
        this.$message.success('创建成功')
        this.$emit('submitted')
        this.close()
      })
    },
    show () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.visible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    close () {
      this.visible = false
      if (this.$refs['form']) {
        this.$refs['form'].clearValidate && this.$refs['form'].clearValidate()
        this.$refs['form'].resetFields && this.$refs['form'].resetFields()
      }
      Object.assign(this.$data, this.$options.data.call(this))
    },
  },
}
</script>

<style lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// src/views/order-review-target-management/components/TargetValueFormDialog.vue